import React, { useEffect, useState, useRef } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { CModal } from '@coreui/react';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../../components/Navigation';
import Pagination from '../../components/Pagination';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import ReactPlayer from 'react-player';

const InstituteDashboardStudyMaterial = () => {
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute();

    const [activeTab, setActiveTab] = useState("syllabus");
    const [visiblePdf, setVisiblePdf] = useState(false);
    const [showPdfLink, setShowPdfLink] = useState(false);
    const [visibleVideo, setVisibleVideo] = useState(false);
    const [videoUrl, setVideoUrl] = useState("");

    const [isFullScreen, setFullScreen] = useState(false);
    const playerRef = useRef(null);
    const [played, setPlayed] = useState(0);
    const [play, setPlay] = useState(false)
    const [volume, setVolume] = useState(0.5);
    const [playbackRate, setPlaybackRate] = useState(1);

    const [pdfBookList, setPdfBookList] = useState([]);
    const [referenceBookList, setReferenceBookList] = useState([]);
    const [syllabusStructureList, setSyllabusStructureList] = useState([]);
    const [videoList, setVideoList] = useState([]);

    const [startIndexPdfBookList, setStartIndexPdfBookList] = useState(null);
    const [startIndexReferenceBookList, setStartIndexReferenceBookList] = useState(null);
    const [startIndexSyllabusStructureList, setStartIndexSyllabusStructureList] = useState(null);
    const [startIndexVideoList, setStartIndexVideoList] = useState(null);

    const [currPagePdfBookList, setCurrPagePdfBookList] = useState(1);
    const [currPageReferenceBookList, setCurrPageReferenceBookList] = useState(1);
    const [currPageSyllabusStructureList, setCurrPageSyllabusStructureList] = useState(1);
    const [currPageVideoList, setCurrPageVideoList] = useState(1);

    const [itemsPerPagePdfBookList, setItemsPerPagePdfBookList] = useState(10);
    const [itemsPerPageReferenceBookList, setItemsPerPageReferenceBookList] = useState(10);
    const [itemsPerPageSyllabusStructureList, setItemsPerPageSyllabusStructureList] = useState(10);
    const [itemsPerPageVideoList, setItemsPerPageVideoList] = useState(10);

    const [displayedDataPdfBookList, setDisplayedDataPdfBookList] = useState([]);
    const [displayedDataReferenceBookList, setDisplayedDataReferenceBookList] = useState([]);
    const [displayedDataSyllabusStructureList, setDisplayedDataSyllabusStructureList] = useState([]);
    const [displayedDataVideoList, setDisplayedDataVideoList] = useState([]);

    const [totalPagesPdfBookList, setTotalPagesPdfBookList] = useState(0);
    const [totalPagesReferenceBookList, setTotalPagesReferenceBookList] = useState(0);
    const [totalPagesSyllabusStructureList, setTotalPagesSyllabusStructureList] = useState(0);
    const [totalPagesVideoList, setTotalPagesVideoList] = useState(0);


    const [pdfSyllabusSort, setPdfSyllabusSort] = useState(null);
    const [pdfSubjectSort, setPdfSubjectSort] = useState(null);
    const [pdfTagSort, setPdfTagSort] = useState(null);
    const [pdfNameSort, setPdfNameSort] = useState(null);
    const [pdfTitleSort, setPdfTitleSort] = useState(null);
    const [pdfDescriptionSort, setPdfDescriptionSort] = useState(null);


    const [referenceBoardSort, setReferenceBoardSort] = useState(null);
    const [referenceMediumSort, setReferenceMediumSort] = useState(null);
    const [referenceClassSort, setReferenceClassSort] = useState(null);
    const [referenceTagSort, setReferenceTagSort] = useState(null);
    const [referenceNameSort, setReferenceNameSort] = useState(null);
    const [referenceTitleSort, setReferenceTitleSort] = useState(null);
    const [referenceDescriptionSort, setReferenceDescriptionSort] = useState(null);

    const [syllabusNameSort, setSyllabusNameSort] = useState(null);
    const [syllabusTypeSort, setSyllabusTypeSort] = useState(null);
    const [syllabusClassSort, setSyllabusClassSort] = useState(null);
    const [syllabusSubjectSort, setSyllabusSubjectSort] = useState(null);
    const [syllabusPublicationSort, setSyllabusPublicationSort] = useState(null);

    const [videoBoardSort, setVideoBoardSort] = useState(null);
    const [videoMediumSort, setVideoMediumSort] = useState(null);
    const [videoTagSort, setVideoTagSort] = useState(null);
    const [videoTitleSort, setVideoTitleSort] = useState(null);
    const [videoDescriptionSort, setVideoDescriptionSort] = useState(null);
    const [videoNameSort, setVideoNameSort] = useState(null);

    const [searchValuePdfBookList, setSearchValuePdfBookList] = useState(null);
    const [searchValueReferenceBookList, setSearchValueReferenceBookList] = useState(null);
    const [searchValueSyllabusStructureList, setSearchValueSyllabusStructureList] = useState(null);
    const [searchValueVideoList, setSearchValueVideoList] = useState(null);

    const searchKeysPdf = ["instituteSyllabusStructureMasterDetails.instituteSyllabusStructureName", "instituteSubjectMasterDetails.subjectName", "tagMasterDetails.tagName", "fileName", "title", "description"];
    const searchKeysReference = ["instituteBoardMappingDetails.boardMasterDetails.boardName", "instituteStreamormediumMappingDetails.streamOrMediumMasterDetails.streamName", "instituteReferenceBookMasterDetails.instituteGradeMasterDetails.gradeName", "tagMasterDetails.tagName", "fileName", "title", "description"];
    const searchKeysSyllabusStructure = ["instituteSyllabusStructureName", "syllabusTypeMasterDetails.syllabusTypeName", "instituteGradeMasterDetails.gradeName", "instituteSyllabusStructureMasterSubjectMappingDetails.instituteSubjectMasterDetails.subjectName", "publicationMasterDetails.publicationName"];
    const searchKeysVideo = ["instituteBoardMappingDetails.boardMasterDetails.boardName", "instituteStreamormediumMappingDetails.streamOrMediumMasterDetails.streamName", "tagMasterDetails.tagName", "title", "description", "fileName"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    const handleSeekChange = (e) => {
        const seekValue = parseFloat(e.target.value);
        setPlayed(seekValue);
        playerRef.current.seekTo(seekValue, 'fraction');
    };

    const handleProgress = (progress) => {
        setPlayed(progress.played);
    };

    const handleVolumeChange = (e) => {
        setVolume(parseFloat(e.target.value));
    };

    const handleSpeedChange = (e) => {
        setPlaybackRate(parseFloat(e.target.value));
    };

    useEffect(() => {
        getPdfBookList();
        getReferenceBookList();
        getSyllabusStructureList();
        getVideoList();
    }, [])

    const getApiUrlPdfBookList = () => {
        return `/get-institute-dashboard-study-material-pdf-book-list?instituteMasterId=${instituteMasterId}`;
    }

    const getApiUrlReferenceBookList = () => {
        return `/get-institute-dashboard-study-material-reference-book-list?instituteMasterId=${instituteMasterId}`;
    }

    const getApiUrlSyllabusStructureList = () => {
        return `/get-institute-dashboard-study-material-syllabus-structure-list?instituteMasterId=${instituteMasterId}`;
    }

    const getApiUrlVideoList = () => {
        return `/get-institute-dashboard-study-material-video-list?instituteMasterId=${instituteMasterId}`;
    }

    const getPdfBookList = async () => {
        try {
            setLoading(true);
            const apiUrl = getApiUrlPdfBookList();
            const response = await authorizedAxiosInstitute.get(apiUrl);
            setPdfBookList(response.data.result);
        } catch (error) {
            setPdfBookList(error?.data?.result || []);
            const errorMsg = error?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        } finally {
            setLoading(false);
        }
    }

    const getReferenceBookList = async () => {
        try {
            setLoading(true);
            const apiUrl = getApiUrlReferenceBookList();
            const response = await authorizedAxiosInstitute.get(apiUrl);
            setReferenceBookList(response.data.result);
        } catch (error) {
            setReferenceBookList(error?.data?.result || []);
            const errorMsg = error?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        } finally {
            setLoading(false);
        }
    }

    const getSyllabusStructureList = async () => {
        try {
            setLoading(true);
            const apiUrl = getApiUrlSyllabusStructureList();
            const response = await authorizedAxiosInstitute.get(apiUrl);
            setSyllabusStructureList(response.data.result);
        } catch (error) {
            setSyllabusStructureList(error?.data?.result || []);
            const errorMsg = error?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        } finally {
            setLoading(false);
        }
    }

    const getVideoList = async () => {
        try {
            setLoading(true);
            const apiUrl = getApiUrlVideoList();
            const response = await authorizedAxiosInstitute.get(apiUrl);
            setVideoList(response.data.result);
        } catch (error) {
            setVideoList(error?.data?.result || []);
            const errorMsg = error?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (searchValuePdfBookList === '' && searchValuePdfBookList !== null) {
            setCurrPagePdfBookList(1);
            getPdfBookList();
        }
    }, [searchValuePdfBookList]);

    useEffect(() => {
        if (searchValueReferenceBookList === '' && searchValueReferenceBookList !== null) {
            setCurrPageReferenceBookList(1);
            getReferenceBookList();
        }
    }, [searchValueReferenceBookList]);

    useEffect(() => {
        if (searchValueSyllabusStructureList === '' && searchValueSyllabusStructureList !== null) {
            setCurrPageSyllabusStructureList(1);
            getSyllabusStructureList();
        }
    }, [searchValueSyllabusStructureList]);

    useEffect(() => {
        if (searchValueVideoList === '' && searchValueVideoList !== null) {
            setCurrPageVideoList(1);
            getVideoList();
        }
    }, [searchValueVideoList]);

    const handleEmptySearchPdfBookList = (e) => {
        setSearchValuePdfBookList(e.target.value);
    }

    const handleEmptySearchReferenceBookList = (e) => {
        setSearchValueReferenceBookList(e.target.value);
    }

    const handleEmptySearchSyllabusStructureList = (e) => {
        setSearchValueSyllabusStructureList(e.target.value);
    }

    const handleEmptySearchVideoList = (e) => {
        setSearchValueVideoList(e.target.value);
    }

    const handleSearchPdfBookList = async () => {
        if (searchValuePdfBookList !== null) {
            setCurrPagePdfBookList(1);
            setPdfBookList(await searchArray("I", getApiUrlPdfBookList(), searchKeysPdf, searchValuePdfBookList.trim()));
        }
    }

    const handleSearchReferenceBookList = async () => {
        if (searchValueReferenceBookList !== null) {
            setCurrPageReferenceBookList(1);
            setReferenceBookList(await searchArray("I", getApiUrlReferenceBookList(), searchKeysReference, searchValueReferenceBookList.trim()));
        }
    }

    const handleSearchSyllabusStructureList = async () => {
        if (searchValueSyllabusStructureList !== null) {
            setCurrPageSyllabusStructureList(1);
            setSyllabusStructureList(await searchArray("I", getApiUrlSyllabusStructureList(), searchKeysSyllabusStructure, searchValueSyllabusStructureList.trim()));
        }
    }

    const handleSearchVideoList = async () => {
        if (searchValueVideoList !== null) {
            setCurrPageVideoList(1);
            setVideoList(await searchArray("I", getApiUrlVideoList(), searchKeysVideo, searchValueVideoList.trim()));
        }
    }

    useEffect(() => {
        setTotalPagesPdfBookList(Math.ceil(pdfBookList.length / itemsPerPagePdfBookList));
        const startIndexPdfBookList = (currPagePdfBookList - 1) * itemsPerPagePdfBookList;
        let endIndexPdf = startIndexPdfBookList + itemsPerPagePdfBookList;

        if (endIndexPdf > pdfBookList.length) {
            endIndexPdf = pdfBookList.length;
        }
        setStartIndexPdfBookList(startIndexPdfBookList);
        setDisplayedDataPdfBookList(pdfBookList.slice(startIndexPdfBookList, endIndexPdf));
    }, [pdfBookList, currPagePdfBookList, itemsPerPagePdfBookList]);

    useEffect(() => {
        setTotalPagesReferenceBookList(Math.ceil(referenceBookList.length / itemsPerPageReferenceBookList));
        const startIndexReferenceBookList = (currPageReferenceBookList - 1) * itemsPerPageReferenceBookList;
        let endIndexReference = startIndexReferenceBookList + itemsPerPageReferenceBookList;

        if (endIndexReference > referenceBookList.length) {
            endIndexReference = referenceBookList.length;
        }
        setStartIndexReferenceBookList(startIndexReferenceBookList);
        setDisplayedDataReferenceBookList(referenceBookList.slice(startIndexReferenceBookList, endIndexReference));
    }, [referenceBookList, currPageReferenceBookList, itemsPerPageReferenceBookList])

    useEffect(() => {
        setTotalPagesSyllabusStructureList(Math.ceil(syllabusStructureList.length / itemsPerPageSyllabusStructureList));
        const startIndexSyllabusStructureList = (currPageSyllabusStructureList - 1) * itemsPerPageSyllabusStructureList;
        let endIndexSyllabus = startIndexSyllabusStructureList + itemsPerPageSyllabusStructureList;

        if (endIndexSyllabus > syllabusStructureList.length) {
            endIndexSyllabus = syllabusStructureList.length;
        }
        setStartIndexSyllabusStructureList(startIndexSyllabusStructureList);
        setDisplayedDataSyllabusStructureList(syllabusStructureList.slice(startIndexSyllabusStructureList, endIndexSyllabus));
    }, [syllabusStructureList, currPageSyllabusStructureList, itemsPerPageSyllabusStructureList])

    useEffect(() => {
        setTotalPagesVideoList(Math.ceil(videoList.length / itemsPerPageVideoList));
        const startIndexVideoList = (currPageVideoList - 1) * itemsPerPageVideoList;
        let endIndexVideo = startIndexVideoList + itemsPerPageVideoList;

        if (endIndexVideo > videoList.length) {
            endIndexVideo = videoList.length;
        }
        setStartIndexVideoList(startIndexVideoList);
        setDisplayedDataVideoList(videoList.slice(startIndexVideoList, endIndexVideo));
    }, [videoList, currPageVideoList, itemsPerPageVideoList])



    useEffect(() => {
        if (syllabusNameSort == true || syllabusNameSort == false) {
            setSyllabusTypeSort(null);
            setSyllabusClassSort(null);
            setSyllabusSubjectSort(null);
            setSyllabusPublicationSort(null);
        }
    }, [syllabusNameSort])

    useEffect(() => {
        if (syllabusTypeSort == true || syllabusTypeSort == false) {
            setSyllabusNameSort(null);
            setSyllabusClassSort(null);
            setSyllabusSubjectSort(null);
            setSyllabusPublicationSort(null);
        }
    }, [syllabusTypeSort])


    useEffect(() => {
        if (syllabusClassSort == true || syllabusClassSort == false) {
            setSyllabusNameSort(null);
            setSyllabusTypeSort(null);
            setSyllabusSubjectSort(null);
            setSyllabusPublicationSort(null);
        }
    }, [syllabusClassSort])

    useEffect(() => {
        if (syllabusSubjectSort == true || syllabusSubjectSort == false) {
            setSyllabusNameSort(null);
            setSyllabusTypeSort(null);
            setSyllabusClassSort(null);
            setSyllabusPublicationSort(null);
        }
    }, [syllabusSubjectSort])

    useEffect(() => {
        if (syllabusPublicationSort == true || syllabusPublicationSort == false) {
            setSyllabusNameSort(null);
            setSyllabusTypeSort(null);
            setSyllabusClassSort(null);
            setSyllabusSubjectSort(null);
        }
    }, [syllabusPublicationSort])



    useEffect(() => {
        if (pdfSyllabusSort == true || pdfSyllabusSort == false) {
            setPdfSubjectSort(null);
            setPdfTagSort(null);
            setPdfNameSort(null);
            setPdfTitleSort(null);
            setPdfDescriptionSort(null);
        }
    }, [pdfSyllabusSort])

    useEffect(() => {
        if (pdfSubjectSort == true || pdfSubjectSort == false) {
            setPdfSyllabusSort(null);
            setPdfTagSort(null);
            setPdfNameSort(null);
            setPdfTitleSort(null);
            setPdfDescriptionSort(null);
        }
    }, [pdfSubjectSort])

    useEffect(() => {
        if (pdfTagSort == true || pdfTagSort == false) {
            setPdfSyllabusSort(null);
            setPdfSubjectSort(null);
            setPdfNameSort(null);
            setPdfTitleSort(null);
            setPdfDescriptionSort(null);
        }
    }, [pdfTagSort])

    useEffect(() => {
        if (pdfNameSort == true || pdfNameSort == false) {
            setPdfSyllabusSort(null);
            setPdfSubjectSort(null);
            setPdfTagSort(null);
            setPdfTitleSort(null);
            setPdfDescriptionSort(null);
        }
    }, [pdfNameSort])

    useEffect(() => {
        if (pdfTitleSort == true || pdfTitleSort == false) {
            setPdfSyllabusSort(null);
            setPdfSubjectSort(null);
            setPdfTagSort(null);
            setPdfNameSort(null);
            setPdfDescriptionSort(null);
        }
    }, [pdfTitleSort])

    useEffect(() => {
        if (pdfDescriptionSort == true || pdfDescriptionSort == false) {
            setPdfSyllabusSort(null);
            setPdfSubjectSort(null);
            setPdfTagSort(null);
            setPdfNameSort(null);
            setPdfTitleSort(null);
        }
    }, [pdfDescriptionSort])



    useEffect(() => {
        if (referenceBoardSort == true || referenceBoardSort == false) {
            setReferenceMediumSort(null);
            setReferenceClassSort(null);
            setReferenceTagSort(null);
            setReferenceNameSort(null);
            setReferenceTitleSort(null);
            setReferenceDescriptionSort(null);
        }
    }, [referenceBoardSort])

    useEffect(() => {
        if (referenceMediumSort == true || referenceMediumSort == false) {
            setReferenceBoardSort(null);
            setReferenceClassSort(null);
            setReferenceTagSort(null);
            setReferenceNameSort(null);
            setReferenceTitleSort(null);
            setReferenceDescriptionSort(null);
        }
    }, [referenceMediumSort])

    useEffect(() => {
        if (referenceClassSort == true || referenceClassSort == false) {
            setReferenceBoardSort(null);
            setReferenceMediumSort(null);
            setReferenceTagSort(null);
            setReferenceNameSort(null);
            setReferenceTitleSort(null);
            setReferenceDescriptionSort(null);
        }
    }, [referenceClassSort])

    useEffect(() => {
        if (referenceTagSort == true || referenceTagSort == false) {
            setReferenceBoardSort(null);
            setReferenceMediumSort(null);
            setReferenceClassSort(null);
            setReferenceNameSort(null);
            setReferenceTitleSort(null);
            setReferenceDescriptionSort(null);
        }
    }, [referenceTagSort])

    useEffect(() => {
        if (referenceNameSort == true || referenceNameSort == false) {
            setReferenceBoardSort(null);
            setReferenceMediumSort(null);
            setReferenceClassSort(null);
            setReferenceTagSort(null);
            setReferenceTitleSort(null);
            setReferenceDescriptionSort(null);
        }
    }, [referenceNameSort])

    useEffect(() => {
        if (referenceTitleSort == true || referenceTitleSort == false) {
            setReferenceBoardSort(null);
            setReferenceMediumSort(null);
            setReferenceClassSort(null);
            setReferenceTagSort(null);
            setReferenceNameSort(null);
            setReferenceDescriptionSort(null);
        }
    }, [referenceTitleSort])

    useEffect(() => {
        if (referenceDescriptionSort == true || referenceDescriptionSort == false) {
            setReferenceBoardSort(null);
            setReferenceMediumSort(null);
            setReferenceClassSort(null);
            setReferenceTagSort(null);
            setReferenceNameSort(null);
            setReferenceTitleSort(null);
        }
    }, [referenceDescriptionSort])


    useEffect(() => {
        if (videoBoardSort == true || videoBoardSort == false) {
            setVideoMediumSort(null);
            setVideoTagSort(null);
            setVideoTitleSort(null);
            setVideoDescriptionSort(null);
            setVideoNameSort(null);
        }
    }, [videoBoardSort])

    useEffect(() => {
        if (videoMediumSort == true || videoMediumSort == false) {
            setVideoBoardSort(null);
            setVideoTagSort(null);
            setVideoTitleSort(null);
            setVideoDescriptionSort(null);
            setVideoNameSort(null);
        }
    }, [videoMediumSort])

    useEffect(() => {
        if (videoTagSort == true || videoTagSort == false) {
            setVideoBoardSort(null);
            setVideoMediumSort(null);
            setVideoTitleSort(null);
            setVideoDescriptionSort(null);
            setVideoNameSort(null);
        }
    }, [videoTagSort])

    useEffect(() => {
        if (videoTitleSort == true || videoTitleSort == false) {
            setVideoBoardSort(null);
            setVideoMediumSort(null);
            setVideoTagSort(null);
            setVideoDescriptionSort(null);
            setVideoNameSort(null);
        }
    }, [videoTitleSort])

    useEffect(() => {
        if (videoDescriptionSort == true || videoDescriptionSort == false) {
            setVideoBoardSort(null);
            setVideoMediumSort(null);
            setVideoTagSort(null);
            setVideoTitleSort(null);
            setVideoNameSort(null);
        }
    }, [videoDescriptionSort])

    useEffect(() => {
        if (videoNameSort == true || videoNameSort == false) {
            setVideoBoardSort(null);
            setVideoMediumSort(null);
            setVideoTagSort(null);
            setVideoTitleSort(null);
            setVideoDescriptionSort(null);
        }
    }, [videoNameSort])



    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Study Material List</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-users-line"></i>Study Material List</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">

                                                <div className="d-grid gap-2">
                                                    <div class="tab-content rounded-bottom custom_table custom_table_width">
                                                        <div className="row">
                                                            <div className="col-md-3">
                                                                <button className={`${activeTab === "syllabus" ? "active" : ""} btn btn-light btn-width`} onClick={() => setActiveTab("syllabus")} >Syllabus</button>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <button className={`${activeTab === "pdf" ? "active" : ""} btn btn-light btn-width`} onClick={() => setActiveTab("pdf")} >PDF</button>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <button className={`${activeTab === "reference" ? "active" : ""} btn btn-light btn-width`} onClick={() => setActiveTab("reference")} >Reference</button>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <button className={`${activeTab === "video" ? "active" : ""} btn btn-light btn-width`} onClick={() => setActiveTab("video")} >Video</button>
                                                            </div>
                                                        </div>

                                                        {activeTab == "pdf" &&
                                                            <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                                <div className='search_btn_row mb-2'>
                                                                    <input
                                                                        className="form-control mr-sm-2"
                                                                        type="Search"
                                                                        placeholder="Search"
                                                                        value={searchValuePdfBookList}
                                                                        onChange={handleEmptySearchPdfBookList}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter') {
                                                                                handleSearchPdfBookList();
                                                                            }
                                                                        }}
                                                                    />
                                                                    <button className="btn btn-outline-primary" onClick={handleSearchPdfBookList}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                                </div>
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                            <th scope="col">
                                                                                Syllabus Name
                                                                                <SortIcon sortState={pdfSyllabusSort} setSortState={setPdfSyllabusSort} setData={setPdfBookList} setCurrPage={setCurrPagePdfBookList} sortingPath={"instituteSyllabusStructureMasterDetails.instituteSyllabusStructureName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Subject Name
                                                                                <SortIcon sortState={pdfSubjectSort} setSortState={setPdfSubjectSort} setData={setPdfBookList} setCurrPage={setCurrPagePdfBookList} sortingPath={"instituteSubjectMasterDetails.subjectName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Tag Name
                                                                                <SortIcon sortState={pdfTagSort} setSortState={setPdfTagSort} setData={setPdfBookList} setCurrPage={setCurrPagePdfBookList} sortingPath={"tagMasterDetails.tagName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Pdf Name
                                                                                <SortIcon sortState={pdfNameSort} setSortState={setPdfNameSort} setData={setPdfBookList} setCurrPage={setCurrPagePdfBookList} sortingPath={"fileName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Title
                                                                                <SortIcon sortState={pdfTitleSort} setSortState={setPdfTitleSort} setData={setPdfBookList} setCurrPage={setCurrPagePdfBookList} sortingPath={"title"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Description
                                                                                <SortIcon sortState={pdfDescriptionSort} setSortState={setPdfDescriptionSort} setData={setPdfBookList} setCurrPage={setCurrPagePdfBookList} sortingPath={"description"} />
                                                                            </th>
                                                                            <th scope="col">Pdf</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            displayedDataPdfBookList?.length > 0 ?
                                                                                displayedDataPdfBookList?.map((pdf, index) => {
                                                                                    return (
                                                                                        <tr>
                                                                                            <th scope="row" className='sl_no'>{startIndexPdfBookList + index + 1}</th>
                                                                                            <td>{pdf?.instituteSyllabusStructureMasterDetails?.instituteSyllabusStructureName}</td>
                                                                                            <td>{pdf?.instituteSubjectMasterDetails?.subjectName}</td>
                                                                                            <td>{pdf?.tagMasterDetails?.tagName}</td>
                                                                                            <td>{pdf.fileName}</td>
                                                                                            <td>{pdf?.title}</td>
                                                                                            <td>{pdf?.description}</td>
                                                                                            <td>
                                                                                                <button className="btn btn-primary view_icon" type="button" onClick={() => {
                                                                                                    setShowPdfLink(pdf.filePath)
                                                                                                    setVisiblePdf(true)
                                                                                                }}><i class="fa fa-eye"></i>PDF</button>
                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                :
                                                                                (<tr>
                                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Pdf Book Available</th>
                                                                                </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                                <Pagination currPage={currPagePdfBookList} setCurrPage={setCurrPagePdfBookList} totalPages={totalPagesPdfBookList} itemsPerPage={itemsPerPagePdfBookList} setItemsPerPage={setItemsPerPagePdfBookList} totalItem={pdfBookList.length} />
                                                            </div>}

                                                        {activeTab == "reference" &&
                                                            <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                                <div className='search_btn_row mb-2'>
                                                                    <input
                                                                        className="form-control mr-sm-2"
                                                                        type="Search"
                                                                        placeholder="Search"
                                                                        value={searchValueReferenceBookList}
                                                                        onChange={handleEmptySearchReferenceBookList}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter') {
                                                                                handleSearchReferenceBookList();
                                                                            }
                                                                        }}
                                                                    />
                                                                    <button className="btn btn-outline-primary" onClick={handleSearchReferenceBookList}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                                </div>
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                            <th scope="col">
                                                                                Board Name
                                                                                <SortIcon sortState={referenceBoardSort} setSortState={setReferenceBoardSort} setData={setReferenceBookList} setCurrPage={setCurrPageReferenceBookList} sortingPath={"instituteBoardMappingDetails.boardMasterDetails.boardName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Medium Name
                                                                                <SortIcon sortState={referenceMediumSort} setSortState={setReferenceMediumSort} setData={setReferenceBookList} setCurrPage={setCurrPageReferenceBookList} sortingPath={"instituteStreamormediumMappingDetails.streamOrMediumMasterDetails.streamName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Class Name
                                                                                <SortIcon sortState={referenceClassSort} setSortState={setReferenceClassSort} setData={setReferenceBookList} setCurrPage={setCurrPageReferenceBookList} sortingPath={"instituteReferenceBookMasterDetails.instituteGradeMasterDetails.gradeName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Tag Name
                                                                                <SortIcon sortState={referenceTagSort} setSortState={setReferenceTagSort} setData={setReferenceBookList} setCurrPage={setCurrPageReferenceBookList} sortingPath={"tagMasterDetails.tagName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Book Name
                                                                                <SortIcon sortState={referenceNameSort} setSortState={setReferenceNameSort} setData={setReferenceBookList} setCurrPage={setCurrPageReferenceBookList} sortingPath={"fileName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Book Title
                                                                                <SortIcon sortState={referenceTitleSort} setSortState={setReferenceTitleSort} setData={setReferenceBookList} setCurrPage={setCurrPageReferenceBookList} sortingPath={"title"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Book Description
                                                                                <SortIcon sortState={referenceDescriptionSort} setSortState={setReferenceDescriptionSort} setData={setReferenceBookList} setCurrPage={setCurrPageReferenceBookList} sortingPath={"description"} />
                                                                            </th>
                                                                            <th scope="col">Book</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            displayedDataReferenceBookList?.length > 0 ?
                                                                                displayedDataReferenceBookList?.map((reference, index) => {
                                                                                    return (
                                                                                        <tr>
                                                                                            <th scope="row" className='sl_no'>{startIndexReferenceBookList + index + 1}</th>
                                                                                            <td>{reference?.instituteBoardMappingDetails?.boardMasterDetails?.boardName}</td>
                                                                                            <td>{reference?.instituteStreamormediumMappingDetails?.streamOrMediumMasterDetails?.streamName}</td>
                                                                                            <td>{reference?.instituteReferenceBookMasterDetails?.map(item => item?.instituteGradeMasterDetails?.gradeName).join(", ")}</td>
                                                                                            <td>{reference?.tagMasterDetails?.tagName}</td>
                                                                                            <td>{reference.fileName}</td>
                                                                                            <td>{reference.title}</td>
                                                                                            <td>{reference.description}</td>
                                                                                            <td>
                                                                                                <button className="btn btn-primary view_icon" type="button" onClick={() => {
                                                                                                    setShowPdfLink(reference.filePath)
                                                                                                    setVisiblePdf(true)
                                                                                                }}><i class="fa fa-eye"></i>Book</button>
                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                :
                                                                                (<tr>
                                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Reference Book Available</th>
                                                                                </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                                <Pagination currPage={currPageReferenceBookList} setCurrPage={setCurrPageReferenceBookList} totalPages={totalPagesReferenceBookList} itemsPerPage={itemsPerPageReferenceBookList} setItemsPerPage={setItemsPerPageReferenceBookList} totalItem={referenceBookList.length} />
                                                            </div>}

                                                        {activeTab == "syllabus" &&
                                                            <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                                <div className='search_btn_row mb-2'>
                                                                    <input
                                                                        className="form-control mr-sm-2"
                                                                        type="Search"
                                                                        placeholder="Search"
                                                                        value={searchValueSyllabusStructureList}
                                                                        onChange={handleEmptySearchSyllabusStructureList}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter') {
                                                                                handleSearchSyllabusStructureList();
                                                                            }
                                                                        }}
                                                                    />
                                                                    <button className="btn btn-outline-primary" onClick={handleSearchSyllabusStructureList}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                                </div>
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                            <th scope="col">
                                                                                Syllabus Name
                                                                                <SortIcon sortState={syllabusNameSort} setSortState={setSyllabusNameSort} setData={setSyllabusStructureList} setCurrPage={setCurrPageSyllabusStructureList} sortingPath={"instituteSyllabusStructureName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Syllabus Type
                                                                                <SortIcon sortState={syllabusTypeSort} setSortState={setSyllabusTypeSort} setData={setSyllabusStructureList} setCurrPage={setCurrPageSyllabusStructureList} sortingPath={"syllabusTypeMasterDetails.syllabusTypeName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Class Name
                                                                                <SortIcon sortState={syllabusClassSort} setSortState={setSyllabusClassSort} setData={setSyllabusStructureList} setCurrPage={setCurrPageSyllabusStructureList} sortingPath={"instituteGradeMasterDetails.gradeName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Subject Name
                                                                                <SortIcon sortState={syllabusSubjectSort} setSortState={setSyllabusSubjectSort} setData={setSyllabusStructureList} setCurrPage={setCurrPageSyllabusStructureList} sortingPath={"instituteSyllabusStructureMasterSubjectMappingDetails.instituteSubjectMasterDetails.subjectName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Publication Name
                                                                                <SortIcon sortState={syllabusPublicationSort} setSortState={setSyllabusPublicationSort} setData={setSyllabusStructureList} setCurrPage={setCurrPageSyllabusStructureList} sortingPath={"publicationMasterDetails.publicationName"} />
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            displayedDataSyllabusStructureList?.length > 0 ?
                                                                                displayedDataSyllabusStructureList?.map((syllabus, index) => {
                                                                                    return (
                                                                                        <tr key={index}>
                                                                                            <th scope="row" className='sl_no'>{startIndexSyllabusStructureList + index + 1}</th>
                                                                                            <td>{syllabus?.instituteSyllabusStructureName}</td>
                                                                                            <td>{syllabus?.syllabusTypeMasterDetails?.syllabusTypeName}</td>
                                                                                            <td>{syllabus?.instituteGradeMasterDetails?.gradeName}</td>
                                                                                            <td>{syllabus?.instituteSyllabusStructureMasterSubjectMappingDetails?.map(item => item?.instituteSubjectMasterDetails?.subjectName).join(", ")}</td>
                                                                                            <td>{syllabus?.publicationMasterDetails?.publicationName}</td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                :
                                                                                (<tr>
                                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Syllabus Structure Available</th>
                                                                                </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                                <Pagination currPage={currPageSyllabusStructureList} setCurrPage={setCurrPageSyllabusStructureList} totalPages={totalPagesSyllabusStructureList} itemsPerPage={itemsPerPageSyllabusStructureList} setItemsPerPage={setItemsPerPageSyllabusStructureList} totalItem={syllabusStructureList.length} />
                                                            </div>}


                                                        {activeTab == "video" &&
                                                            <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                                <div className='search_btn_row mb-2'>
                                                                    <input
                                                                        className="form-control mr-sm-2"
                                                                        type="Search"
                                                                        placeholder="Search"
                                                                        value={searchValueVideoList}
                                                                        onChange={handleEmptySearchVideoList}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter') {
                                                                                handleSearchVideoList();
                                                                            }
                                                                        }}
                                                                    />
                                                                    <button className="btn btn-outline-primary" onClick={handleSearchVideoList}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                                </div>
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col" className='sl_no'>Sr. No.</th>
                                                                            <th scope="col">
                                                                                Board Name
                                                                                <SortIcon sortState={videoBoardSort} setSortState={setVideoBoardSort} setData={setVideoList} setCurrPage={setCurrPageVideoList} sortingPath={"instituteBoardMappingDetails.boardMasterDetails.boardName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Medium Name
                                                                                <SortIcon sortState={videoMediumSort} setSortState={setVideoMediumSort} setData={setVideoList} setCurrPage={setCurrPageVideoList} sortingPath={"instituteStreamormediumMappingDetails.streamOrMediumMasterDetails.streamName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Tag Name
                                                                                <SortIcon sortState={videoTagSort} setSortState={setVideoTagSort} setData={setVideoList} setCurrPage={setCurrPageVideoList} sortingPath={"tagMasterDetails.tagName"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Title
                                                                                <SortIcon sortState={videoTitleSort} setSortState={setVideoTitleSort} setData={setVideoList} setCurrPage={setCurrPageVideoList} sortingPath={"title"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Description
                                                                                <SortIcon sortState={videoDescriptionSort} setSortState={setVideoDescriptionSort} setData={setVideoList} setCurrPage={setCurrPageVideoList} sortingPath={"description"} />
                                                                            </th>
                                                                            <th scope="col">
                                                                                Video Name
                                                                                <SortIcon sortState={videoNameSort} setSortState={setVideoNameSort} setData={setVideoList} setCurrPage={setCurrPageVideoList} sortingPath={"fileName"} />
                                                                            </th>
                                                                            <th scope='col'>
                                                                                Video
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {
                                                                            displayedDataVideoList?.length > 0 ?
                                                                                displayedDataVideoList?.map((video, index) => {
                                                                                    return (
                                                                                        <tr>
                                                                                            <th scope="row" className='sl_no'>{startIndexVideoList + index + 1}</th>
                                                                                            <td>{video?.instituteBoardMappingDetails?.boardMasterDetails?.boardName}</td>
                                                                                            <td>{video?.instituteStreamormediumMappingDetails?.streamOrMediumMasterDetails?.streamName}</td>
                                                                                            <td>{video?.tagMasterDetails?.tagName}</td>
                                                                                            <td>{video?.title}</td>
                                                                                            <td>{video?.description}</td>
                                                                                            <td>{video?.fileName}</td>
                                                                                            <td>
                                                                                                <button className="btn btn-primary view_icon" type="button" onClick={() => {
                                                                                                    setVideoUrl(video?.filePath)
                                                                                                    setVisibleVideo(true)
                                                                                                }}><i class="fa fa-eye"></i></button>
                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                :
                                                                                (<tr>
                                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Video Available</th>
                                                                                </tr>)
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                                <Pagination currPage={currPageVideoList} setCurrPage={setCurrPageVideoList} totalPages={totalPagesVideoList} itemsPerPage={itemsPerPageVideoList} setItemsPerPage={setItemsPerPageVideoList} totalItem={videoList.length} />
                                                            </div>}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />


            <CModal
                visible={visiblePdf}
                onClose={() => setVisiblePdf(false)}
                aria-labelledby="LiveDemoExampleLabel"
            >
                <div className="book pdf-modal">
                    <iframe height={450} width={"100%"} className="page" src={showPdfLink}></iframe>
                    <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisiblePdf(false)}>
                        Close
                    </button>
                </div>
            </CModal>

            <CModal
                backdrop="static"
                visible={visibleVideo}
                onClose={() => setVisibleVideo(false)}
                aria-labelledby="LiveDemoExampleLabel"
                className={isFullScreen ? "full_scr_view" : ""}
            >
                <button className="close-button video-close" onClick={() => setVisibleVideo(false)}><i class="fa fa-window-close fa-2xl" aria-hidden="true"></i></button>
                <div className="test test-player">
                    <ReactPlayer
                        ref={playerRef}
                        url={videoUrl}
                        playing={play}
                        volume={volume}
                        onProgress={handleProgress}
                        playbackRate={playbackRate}
                    >
                    </ReactPlayer>
                    <div className="overlay-layer">
                        <div className="trigger" onClick={() => setPlay(!play)} >Play</div>
                    </div>
                </div>
                <div className="video_content_bottom">
                    <div className="video_progress">
                        <input
                            type="range"
                            min={0}
                            max={1}
                            step="any"
                            value={played}
                            onChange={handleSeekChange}
                            className="input_slider"
                        />
                    </div>
                    <div className='play_pause_sound'>
                        <div className='sound'>
                            {!play ? <button onClick={() => setPlay(true)} className="play_pause_btn"> <i class="fa fa-play"></i></button> :
                                <button onClick={() => setPlay(false)} className="play_pause_btn"><i class="fa fa-pause"></i></button>}
                            {volume >= 0.5 && <button className='play_pause_btn'>
                                <i class="fa fa-volume-high"></i>
                            </button>}
                            {volume < 0.5 && volume > 0 && <button className='play_pause_btn'>
                                <i class="fa fa-volume-low"></i>
                            </button>}
                            {volume == 0 && <button className='play_pause_btn'>
                                <i class="fa fa-volume-xmark"></i>
                            </button>}
                            <div className='sound_bar'>
                                <input
                                    type="range"
                                    value={volume}
                                    onChange={handleVolumeChange}
                                    min="0"
                                    max="1"
                                    step="0.01"
                                    className="input_slider"
                                />
                            </div>
                        </div>
                        <div className='playbeack_speed'>
                            <span>Playback speed</span>
                            <select onClick={handleSpeedChange}>
                                <option value={0.25}>0.25</option>
                                <option value={0.5}>0.5</option>
                                <option value={0.75}>0.75</option>
                                <option selected value={1}>Normal</option>
                                <option value={1.25}>1.25</option>
                                <option value={1.5}>1.5</option>
                                <option value={1.75}>1.75</option>
                            </select>
                        </div>

                        <div className='fullscreen_mode'>
                            <button className='full_scr_btn' onClick={() => setFullScreen(!isFullScreen)}>{isFullScreen ? <i className="fa fa-compress"></i> : <i className="fa fa-expand"></i>}</button>
                        </div>
                    </div>
                </div>
            </CModal>
        </>
    )
};

export default InstituteDashboardStudyMaterial;